import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { MdOutlineArrowOutward } from "react-icons/md";
import './serviceGrid.css'
import sc1 from "../Assets/sc1.png"
import sc2 from "../Assets/sc2.png"
import sccaregiver from "../Assets/sccaregiver.png"
import sc3 from "../Assets/sc3.png"
import sc4 from "../Assets/sc4.png"
import sc5 from "../Assets/sc5.png"
import sc6 from "../Assets/sc6.png"
import sc7 from "../Assets/sc7.png"
import sc8 from "../Assets/sc8.png"
import sc9 from "../Assets/sc9.png"
import sc10 from "../Assets/sc10.png"
const ServicesGrid = ({ title, exclude, className = "" }) => {

  const services = [
    {
      img: sc1,
      title: "Home Nurse",
      desc: `With innovative technology and
compassionate nursing, we're transforming
the home into a place of healing, comfort,...`
    },
    {
      img: sccaregiver,
      title: "Care Giver",
      desc: `Whether it's assisting with daily activities,
providing medical support, or simply
offering a listening ear, our caregivers ...`
    },
    {
      img: sc2,
      title: "Baby Care",
      desc: `Our baby care services are designed to
make the early days of parenthood easier
and more enjoyable for you, providing ...`
    },
    {
      img: sc3,
      title: "Home ICU Setup",
      desc: `Transforming healthcare with our innovative
home ICU setup. Say goodbye to hospital
stays and hello to comfort, convenience...`
    },
    {
      img: sc4,
      title: "Medical Equipment",
      desc: `Ordering medical equipment from us means
choosing excellence in both products and
services. With our extensive selection ...`
    },
    {
      img: sc5,
      title: "Doctor Consultation",
      desc: `Our team understands that every patient is
unique, which is why we tailor our 
consultations to your specific needs and ...`
    },
    {
      img: sc6,
      title: "Physiotherapy",
      desc: `Say goodbye to the hassle of clinic visits
and hello to rehabilitation in the comfort
of your own home, where you can truly ...`
    },
    {
      img: sc7,
      title: "Medicine Home Delivery",
      desc: `With our home delivery service, you can
upload your prescriptions and we'll handle
the rest. Whether you're managing ...`
    },
    {
      img: sc8,
      title: "Health Checks",
      desc: `Don't let your health take a back seat – take
control of your well-being today with our
home health checks. Book now and...`
    },
    {
      img: sc9,
      title: "Diagnostics",
      desc: `Imagine having the convenience of
laboratory-quality diagnostics without
ever leaving the comfort of your home...`
    },
    {
      img: sc10,
      title: "Radiology",
      desc: `We bring advanced radiology technology
directly to your doorstep, ensuring you
can undergo essential tests without ...`
    },
  ];

  const [showAll, setShowAll] = useState(false);

  const filteredServices = services.filter(
    (service) => service.title !== exclude
  );

  const visibleServices = showAll ? filteredServices : filteredServices.slice(0, 8);

  return (
    <div className={`other-services ${className}`}>
      <h2>{title}</h2>

      <div className="services-grid">
        {visibleServices.map((service, index) => (
          <Link
            to={
              service.link ||
              `/${service.title.toLowerCase().replace(/\s+/g, "-")}`
            }
            key={index}
            className={`service-card ${index === 7 ? "view-all-card" : ""}`}
            style={{
              textDecoration: "none",
              color: "inherit",
              position: "relative",
            }}
          >
            <img src={service.img} alt={`service-img-${index}`} />
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
            <span className="view-more">
              View More <MdOutlineArrowOutward size={18} />
            </span>

            {/* 👇 overlay visible only on 8th card hover */}
            {!showAll && index === 7 && (
              <div
                className="view-all-overlay"
                onClick={(e) => {
                  e.preventDefault();
                  setShowAll(true);
                }}
              >
                <span>View All <MdOutlineArrowOutward size={22} /></span>
              </div>
            )}
          </Link>
        ))}
      </div>
    </div>
  );

};

export default ServicesGrid;
